import React from 'react';
import Box from '@rexlabs/box';
import { PortalTarget } from '@rexlabs/portal';

function PopupTarget() {
  return (
    <PortalTarget name='popups'>
      {({ children }) => (
        <>
          {children.map((child, i) => (
            <Box key={i}>{child}</Box>
          ))}
        </>
      )}
    </PortalTarget>
  );
}

export default PopupTarget;
window.__Components.PopupTarget = PopupTarget;
